import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Observable, map } from 'rxjs';
import { GroupDto } from '@oracychampions/api-interfaces';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { tablerArrowLeft } from '@ng-icons/tabler-icons';

@Component({
  selector: 'oc-admin-container',
  standalone: true,
  imports: [CommonModule, RouterModule, NgIconComponent],
  providers: [
    provideIcons({
      tablerArrowLeft,
    }),
  ],
  template: `
    <div class="d-flex">
      <div class="oc-menu">
        <div>
          <a [routerLink]="['/dashboard']" class="mt-1 mb-3 btn btn-secondary btn-rounded"
            ><ng-icon name="tablerArrowLeft" size="20"></ng-icon> Dashboard</a
          >
          <h3 class="mt-2 mb-3">Admin</h3>
          <ul class="list-group">
            <a class="list-group-item list-group-item-action" routerLinkActive="active" [routerLink]="['groups']"
              >Classes</a
            >
            <a class="list-group-item list-group-item-action" routerLinkActive="active" [routerLink]="['users']"
              >Users</a
            >
            <a class="list-group-item list-group-item-action" routerLinkActive="active" [routerLink]="['invites']"
              >Invites</a
            >
          </ul>
        </div>
      </div>
      <div class="flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: ``,
})
export class AdminContainerComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  public groups$: Observable<GroupDto[]>;
  public groupId: string;

  constructor() {
    this.groups$ = this.route.data.pipe(map((data) => data['groups']));
    this.groupId = this.route.snapshot.params['id'];
  }

  onMenuChange(event: Event) {
    const groupId = (event.target as HTMLSelectElement).value;
    this.router.navigate(['/group', groupId]);
  }
}
